export enum EmailJobCronPattern {
  DAILY = '0 12 * * *', // Every day at 12:00
  WEEKLY = '0 12 * * 1', // Every Monday at 12:00
  MONTHLY = '0 12 1 * *', // 1st day of each month at 12:00
}
